<template>
  <el-container>
    <el-aside width="300px">
      <el-card header="用户列表" class="user-list">
        <div v-for="user in users" :class="'user-item '+(queryForm.userId == user.userId ? 'active':'')"
             @click="userChange(user.userId)">
          <span>{{user.userName}}</span>
        </div>
      </el-card>
    </el-aside>
    <el-main>
      <title-bar title="设备授权">
        <el-button type="primary" @click="save" :loading="loading">
          保存
        </el-button>
      </title-bar>
      <el-table ref="tab" stripe :data="records" :border="true" v-loading="loading"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="deviceCode" label="设备编号" align="center" min-width="130"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" min-width="130"></el-table-column>
        <el-table-column prop="address" label="地址" min-width="200"></el-table-column>
        <el-table-column prop="deviceTypeName" label="设备类型" align="center" width="60"></el-table-column>
        <el-table-column prop="softVersion" label="软件版本" align="center" width="60"></el-table-column>
        <el-table-column prop="address" label="地址"></el-table-column>
        <!--        <el-table-column prop="inFanCount" label="进风(台)" align="center" width="80"></el-table-column>-->
        <!--        <el-table-column prop="outFanCount" label="出风(台)" align="center" width="80"></el-table-column>-->
        <!--        <el-table-column prop="acCount" label="空调数量(台)" align="center" width="80"></el-table-column>-->
        <el-table-column prop="acPower" label="空调总功率(W)" align="center" width="80"></el-table-column>
        <el-table-column prop="kwh" label="电表电量(KWH)" align="center" width="80"></el-table-column>
        <el-table-column prop="clothLeftTime" label="无纺布剩余(天)" align="center" width="80">
          <template slot-scope="{ row }">
            <span v-if="row.clothLeftTime === undefined">-</span>
            <span v-else :class="row.clothLeftTime < 30*24 ? 'color-error':''">{{Math.round(row.clothLeftTime/24)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lat" label="坐标" align="center" width="60">
          <template slot-scope="{ row }">
            <el-button v-if="!!row.lat" type="text" icon="fa fa-map-marker" @click="showMap(row)" style="font-size: 16px"></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="valid" label="启用" align="center" width="60">
          <template slot-scope="{ row }">
            <span v-if="row.valid" class="color-success">启用</span>
            <span v-else class="color-error">禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="warningInfo" label="告警信息" width="200"></el-table-column>
        <el-table-column prop="online" label="在线" align="center" width="60" fixed="right">
          <template slot-scope="{ row }">
            <span v-if="row.online" class="color-success">在线</span>
            <span v-else class="color-error">离线</span>
          </template>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="getDevices"></table-pagination>
    </el-main>
  </el-container>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import AppUpload from "@/components/app-version/AppUpload";
export default {
  name: 'MyDeviceList',
  components: {AppUpload, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      queryForm: {
        userId: null,
        page: 1,
        limit: 10
      },
      total: 0,
      users: [],
      records: [],
      selectedRecords: [],
      device: null
    }
  },
  created() {
    this.getUsers();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    getUsers() {
      this.loading = true;
      this.postForm("/user/myUsers", null, true).then(dr => {
        this.users = dr.rows;
      }).finally(()=>{
        this.loading = false;
      })
    },
    userChange(userId) {
      this.queryForm.userId = userId;
      this.getDevices();
    },
    getDevices() {
      this.loading = true;
      this.postForm("/person-device/getPersonDeviceList", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
        this.$nextTick(()=>{
          this.records.forEach(d=>{
            if(d.checked) {
              this.selectedRecords.push(d);
              this.$refs.tab.toggleRowSelection(d);
            }
          });
        })
      }).finally(()=>{
        this.loading = false;
      })
    },
    handleSelectionChange(rows){
      this.selectedRecords = rows;
    },
    save() {
      if(this.records.length == 0){
        this.$message.warning("请选择用户");
        return;
      }
      let data = [];
      this.records.forEach(d => {
        let checked = false;
        for (let i = 0; i < this.selectedRecords.length; i++) {
          if(d.deviceCode == this.selectedRecords[i].deviceCode) {
            checked = true;
            break;
          }
        }
        data.push({
          deviceCode: d.deviceCode,
          checked: checked
        });
      });
      this.loading = true;
      this.postJson("/person-device/save?userId="+this.queryForm.userId,data,true).finally(()=>{
        this.loading = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/css/variables";
.user-list{
  .user-item{
    cursor: pointer;
    padding: 5px;
    margin-bottom: 10px;
  }
  .user-item.active{
    color: $color-primary;
  }
}

</style>